import { DomainActions, UPDATE_DOMAIN } from "./action";
import produce from "immer";
import { DomainRoot } from "../../typings/document-types";
import { AppState } from "..";

export interface DomainState
{
    domain: DomainRoot | undefined;
}

const initialState: DomainState = {
    domain: undefined
};

export const reducer = (domainState = initialState, action: DomainActions): DomainState => produce(domainState, draft =>
{
    switch (action.type)
    {
        case UPDATE_DOMAIN: {
            draft.domain = action.domain;
        }
    }
});

export const getDomain = (state: DomainState) => state.domain;

export const getSponsorDisclaimer = (state: AppState) => state.domain.domain?.sponsorDisclaimer;

export const getGoogleAnalyticsId = (state: AppState) => state.domain.domain?.googleAnalyticsId;

export default reducer;